export default "__VITE_ASSET__DtNpZSDm__"